import { AudiencesState } from 'features/audiences/store/types';

const getAudienceModelIdById = (state: AudiencesState, audienceId: number | undefined) => {
  return state.audiences.find(audience => audience.id === audienceId)?.model_id;
};

export default getAudienceModelIdById;
